import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { subscriptionPlans } from 'config';
import UsageBar from 'components/sites/usage-bar';

const SubscriptionPlanDetails = ({ planId = 'basic', nextBillingDate, nextPlanId, paidThroughDate, price }) => {
  const plan = subscriptionPlans[planId] ? subscriptionPlans[planId] : subscriptionPlans.basic;
  const nextPlan = subscriptionPlans[nextPlanId] ? subscriptionPlans[nextPlanId] : subscriptionPlans.basic;

  return (<div className="form-group">
    <p className="form-control-static mb-0">
      <b>{plan.title}</b> {planId !== nextPlanId && !!paidThroughDate &&
      (<span>
        until <b>{moment(paidThroughDate).format('Y-MM-DD')}</b>.
        After that your plan will change to <b>{nextPlan.title}</b>.
      </span>)
      }
    </p>
    {plan.limit !== 'unlimited' && <UsageBar/>}
    {!!nextBillingDate &&
    (<p className="form-control-static mb-0">
      Next payment due: <b>{moment(nextBillingDate).format('Y-MM-DD')}</b>
    </p>)
    }
    {!!price &&
    (<p className="form-control-static mb-0">
      Next payment amount: <b>${price}</b>
    </p>)
    }
  </div>)
};

SubscriptionPlanDetails.propTypes = {
  customerId: PropTypes.string,
  nextBillingDate: PropTypes.string,
  nextPlanId: PropTypes.string,
  paidThroughDate: PropTypes.string,
  planId: PropTypes.string,
  price: PropTypes.string
};

SubscriptionPlanDetails.defaultProps = {
  planId: 'basic',
};

export default SubscriptionPlanDetails;



// WEBPACK FOOTER //
// ./src/components/account/subscription/plan-info.js